import { render, staticRenderFns } from "./ChatroomManage.vue?vue&type=template&id=efed5a76&"
import script from "./ChatroomManage.vue?vue&type=script&lang=js&"
export * from "./ChatroomManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports